import React from "react";

type ValueContainerProps = {
  id?: string;
  value: string | number | React.ReactNode;
  unit?: string;
  highlight?: boolean;
  color?: string;
  onDoubleClick?: () => void;
  children?: React.ReactNode;
  column?: boolean;
};

const ValueContainer: React.FC<ValueContainerProps> = ({
  id,
  value,
  unit,
  highlight,
  color,
  onDoubleClick,
  children,
  column = false,
}) => {
  return (
    <>
      <div
        id={id}
        className={`${column ? "flex flex-column" : "flex flex-row gap-1 align-items-end"} value-container ${
          highlight ? "highlight-value" : ""
        }`}
        style={{ color: highlight ? "" : color }}
        onDoubleClick={onDoubleClick}
      >
        <div className="value cursor-pointer font-bold">{value}</div>
        {unit && <div className="unit cursor-pointer font-bold">{unit}</div>}
      </div>
      {children}
    </>
  );
};

export default ValueContainer;
